var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketStreamlineFlex1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.965 7.78636C16.4578 5.13156 15.0303 2.82122 11.9999 1.6557C8.96959 2.82122 7.54202 5.13152 7.03475 7.7863C6.20792 12.1136 7.82618 17.3563 8.9344 20.0475C11.0603 20.9879 12.9392 20.9879 15.065 20.0475C16.1733 17.3563 17.7919 12.1137 16.965 7.78636Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9383 7.6533C16.4092 5.05451 14.9791 2.8017 11.9995 1.6557C9.01985 2.80172 7.58978 5.05456 7.06055 7.65338C10.3723 7.31401 13.6267 7.31398 16.9383 7.6533Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86826 11.9714C4.51439 13.337 3.25716 18.5705 4.5742 21.4015C4.90197 22.106 5.79761 22.1412 6.32269 21.5684C6.52227 21.3507 6.71795 21.1249 6.91185 20.9012C7.47983 20.2457 8.03234 19.608 8.62173 19.2443C7.91811 17.3973 7.1127 14.7139 6.86826 11.9714Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1286 11.9714C19.4825 13.337 20.7397 18.5705 19.4227 21.4015C19.0948 22.106 18.1992 22.1412 17.6742 21.5684C17.4746 21.3507 17.2789 21.1249 17.085 20.9012C16.517 20.2457 15.9645 19.608 15.3751 19.2443C16.0787 17.3973 16.8842 14.7139 17.1286 11.9714Z",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1107 16.2668V22.3443",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketStreamlineFlex1);
export default __webpack_public_path__ + "static/media/Rocket--Streamline-Flex 1.bcad2af36793743d7e6be9f4fc210d1a.svg";
export { ForwardRef as ReactComponent };